// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { BidPackageDetailPage_TradeFragmentDoc } from '../../components/AddTradePartnerModal.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type UploadBidV2ModalQueryVariables = Types.Exact<{
  costCodes: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
  markets?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
}>;


export type UploadBidV2ModalQuery = { __typename?: 'Query', tradePartners: Array<{ __typename?: 'TradePartner', id: string, name: string, costCodes: Array<{ __typename?: 'CostCode', id: string }> }> };


export const UploadBidV2ModalDocument = gql`
    query UploadBidV2Modal($costCodes: [ID!]!, $markets: [ID!]) {
  tradePartners(filter: {coversCostCodes: $costCodes, markets: $markets}) {
    ...BidPackageDetailPage_Trade
  }
}
    ${BidPackageDetailPage_TradeFragmentDoc}`;

/**
 * __useUploadBidV2ModalQuery__
 *
 * To run a query within a React component, call `useUploadBidV2ModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useUploadBidV2ModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUploadBidV2ModalQuery({
 *   variables: {
 *      costCodes: // value for 'costCodes'
 *      markets: // value for 'markets'
 *   },
 * });
 */
export function useUploadBidV2ModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UploadBidV2ModalQuery, UploadBidV2ModalQueryVariables> & ({ variables: UploadBidV2ModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UploadBidV2ModalQuery, UploadBidV2ModalQueryVariables>(UploadBidV2ModalDocument, options);
      }
export function useUploadBidV2ModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UploadBidV2ModalQuery, UploadBidV2ModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UploadBidV2ModalQuery, UploadBidV2ModalQueryVariables>(UploadBidV2ModalDocument, options);
        }
// @ts-ignore
export function useUploadBidV2ModalSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UploadBidV2ModalQuery, UploadBidV2ModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UploadBidV2ModalQuery, UploadBidV2ModalQueryVariables>;
export function useUploadBidV2ModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UploadBidV2ModalQuery, UploadBidV2ModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UploadBidV2ModalQuery | undefined, UploadBidV2ModalQueryVariables>;
export function useUploadBidV2ModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UploadBidV2ModalQuery, UploadBidV2ModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UploadBidV2ModalQuery, UploadBidV2ModalQueryVariables>(UploadBidV2ModalDocument, options);
        }
export type UploadBidV2ModalQueryHookResult = ReturnType<typeof useUploadBidV2ModalQuery>;
export type UploadBidV2ModalLazyQueryHookResult = ReturnType<typeof useUploadBidV2ModalLazyQuery>;
export type UploadBidV2ModalSuspenseQueryHookResult = ReturnType<typeof useUploadBidV2ModalSuspenseQuery>;
export type UploadBidV2ModalQueryResult = ApolloReactCommon.QueryResult<UploadBidV2ModalQuery, UploadBidV2ModalQueryVariables>;